import React, { Component } from 'react';
import { observer } from "mobx-react";
import { DatePicker, Input, Button, Icon, InputNumber, message } from 'utils/ui';
import { editReceipt } from '../api_calls/receipt.js';
import _ from "underscore";
import moment from "moment";
import MyListStore from '../stores/MyListStore.js';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';

@observer(["UserStore", "FamilyStore", "MyListStore", "AuthStore"])
class EditReceiptModal extends Component {
    constructor(props) {
        super(props);
        this.state = { submittingEdits: false };
        this.onSubmitEdits = this.onSubmitEdits.bind(this);
    }
    componentDidMount() {


    }

    onSubmitEdits() {
        console.log(this.state);
        let clone = _.clone(this.state);
        let propsClone = _.clone(this.props.rct);
        delete clone.submittingEdits;
        console.log(_.extend(propsClone, clone));
        let newRct = _.extend(propsClone, clone);
        let rctId = propsClone._id;
        delete newRct._id;
        const token = this.props.UserStore.childViewActive ? this.props.UserStore.activeChild.jwt : this.props.AuthStore.userAuth.auth.accessToken;
        this.props.closeModalCallback();
        editReceipt(rctId, token, { $set: newRct }).then((res) => {
            console.log(res);
            if (res.status && (res.status === 200)) {
                message.success("Receipt updated!");
                this.props.MyListStore.loadReceipts(token);
            }
            else {
                message.error("Problem updating receipt...");
            }
        });
    }

    render() {
        const { FamilyStore } = this.props;
        let wisher = {};
        let title, price = "";
        let giftFor, desc = "";
        let boughtDate = null;
        if (this.props.rct) {
            wisher = this.props.UserStore.getUser(this.props.rct.wisher) || this.props.rct.wisher;
            title = this.props.rct.title;
            price = this.props.rct.price;
            boughtDate = moment(this.props.rct.timePurchased);
            desc = this.props.rct.description;
            giftFor = _.findWhere(FamilyStore.family, { _id: this.props.rct.wisher }) ? _.findWhere(FamilyStore.family, { _id: this.props.rct.wisher }).name :
                this.props.rct.wisher;
        }

        return (<ModalShell className="register-modal" overlayClassName="register-modal-overlay"
            isOpen={this.props.modalOpen}
            onRequestClose={() => { (this.state.submittingEdits ? console.log("tried to close") : this.props.closeModalCallback()) }}
            maxWidth={600}>
            <ModalBody className="ui-modal-surface-compact" title={`Gift For ${wisher ? wisher.name || wisher : ""}`} subtitle="Update receipt details">
                <div className="ui-modal-form-grid">
                    <FormField label="Title">
                        <Input defaultValue={title} onChange={(e) => { this.setState({ title: e.target.value }) }} placeholder="Title" />
                    </FormField>
                    <FormField label="Description">
                        <Input defaultValue={desc} onChange={(e) => { this.setState({ description: e.target.value }) }} placeholder="Description" />
                    </FormField>
                    <FormField label="For">
                        <Input defaultValue={giftFor} onChange={(e) => { this.setState({ wisher: e.target.value }) }} placeholder="For" />
                    </FormField>
                    <FormField label="Price">
                        <InputNumber defaultValue={price} onChange={(value) => { this.setState({ price: value }) }} placeholder="Price" style={{ width: '100%' }} />
                    </FormField>
                    <FormField label="Date Bought">
                        <DatePicker onChange={(value) => { this.setState({ timePurchased: value ? value.unix() * 1000 : null }) }} defaultValue={boughtDate} style={{ width: '100%' }} />
                    </FormField>
                </div>
                <div className="ui-modal-actions">
                    <Button className="AppFont btn-submit ui-btn-success" onClick={this.onSubmitEdits} size="large"><Icon type="check-circle" /> Submit Edits</Button>
                    <Button className="AppFont btn-cancel ui-btn-danger" onClick={() => { this.props.closeModalCallback() }} size="large"><Icon type="close" /> Cancel</Button>
                </div>
            </ModalBody>
        </ModalShell>
        );
    }
}

export default EditReceiptModal;